import {FC, PropsWithChildren, useMemo, useState} from 'react'
import {HeaderProps} from 'react-table'
import {DataCDR} from '../../core/_models'
import clsx from 'clsx'
import {useAppDispatch, useAppSelector} from '../../../../hooks/redux'
import {setQuery, updateQuery} from '../../slices/cdrFilterSlice'
import {shallowEqual} from 'react-redux'

type Props = {
  className?: string
  title?: string
  tableProps: PropsWithChildren<HeaderProps<DataCDR>>
}

const CDRCustomHeader: FC<Props> = ({className, title, tableProps}) => {
  const id = tableProps.column.id
  const dispatch = useAppDispatch()
  const [ignoreOrderColumns] = useState(['id', 'record_url', 'llm_analysis'])
  const query = useAppSelector((state) => state.cdrFilter.query, shallowEqual)

  const isSelectedForSorting = useMemo(() => {
    return query?.sort_by && query.sort_by.replace(/\.(asc|desc)$/, '') === id
  }, [query, id])

  const order = useMemo<'asc' | 'desc' | null>(() => {
    if (!query?.sort_by) return null
    if (query?.sort_by.endsWith('.asc')) return 'asc'
    if (query?.sort_by.endsWith('.desc')) return 'desc'
    return null
  }, [query?.sort_by])

  const sortColumn = () => {
    if (ignoreOrderColumns.includes(id)) {
      return
    }

    if (!isSelectedForSorting) {
      dispatch(updateQuery({...query, sort_by: `${id}.asc`}))
      return
    }

    if (isSelectedForSorting && order !== undefined) {
      if (order === 'asc') {
        dispatch(updateQuery({...query, sort_by: `${id}.desc`}))
        return
      }

      const {sort_by, ...rest} = query || {}
      dispatch(setQuery(rest))
    }
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(className, isSelectedForSorting && order !== undefined && `table-sort-${order}`)}
      style={{
        fontSize: '10px',
        fontWeight: 600,
        cursor: ignoreOrderColumns.includes(id) ? 'default' : 'pointer',
        userSelect: 'none',
      }}
      onClick={sortColumn}
    >
      {title}
    </th>
  )
}

export {CDRCustomHeader}
